@use '@design/design-tokens/typography/typography' as *;

.pillContainer {
  flex: 1;
}

.styledHeader {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.assetHeader {
  display: flex;
  width: calc(100% - 40px);
  flex-direction: column;
  align-items: start;
  justify-content: center;

  :global(#company-label) {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :global(#company-name) {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    @include typography-v2-body-sm;
    color: var(--text-soft);
  }
}

.styledLogoImg {
  height: var(--logo-size);
  width: var(--logo-size);
  border-radius: 50%;
  background-color: var(--surface-inverse);
}

.logoFallback {
  display: flex;
  height: var(--logo-size);
  width: var(--logo-size);
  border-radius: 50%;
  background-color: var(--surface-default);
  color: var(--text-default);
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  @include typography-v2-body-sm;
  font-weight: 500;
}
